import {
	type AnyFrontendStage,
	type FrontendPlacementMessage,
} from '@post-office/message-maker-browser/types';
import { noValidation } from '@post-office/message-maker-browser/message-helpers';
import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';
import { PlacementFrontend } from '@post-office/browser--growth/confluence-side-nav';
import {
	ConfluenceSideNavMessage,
	type ConfluenceSideNavMessageProps,
} from './ConfluenceSideNavMessage';

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: AnyFrontendStage;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<ConfluenceSideNavMessageProps>(),
		Component: ConfluenceSideNavMessage,
	},
});
